/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable'
import { Aisle } from './Aisle'
import { useDeviceMediaQuery } from '../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { DroppableZone } from './DroppableZone'
import { useTranslation } from 'react-i18next'


const WithdrawnZone = ({
                           withdrawnAisles = [],
                           onChange,
                       }) => {
    const [t] = useTranslation()
    const {isMobile, isTablet} = useDeviceMediaQuery()

    const handleOnWithdrawnAisleChange = (aisleId, newAisles) => {
        const updatedAisles = withdrawnAisles.map(aisle => {
            if (aisle.id === aisleId) {
                return {
                    ...aisle,
                    aisles: newAisles,
                }
            }
            return aisle
        })

        onChange(updatedAisles)
    }

    const ITEMS_PER_ROW = isMobile ? 1 : (isTablet ? 3 : 5)

    return (
      <div css={css`
          display: flex;
          position: relative;
          width: 100%;
      `}>
          <div css={css`
              display: flex;
              flex-direction: column;
              width: 100%;
          `}>
              <DroppableZone
                id="withdrawn-zone"
                css={css`
                    padding: ${isMobile ? '0.5rem' : '1rem'};
                    background-color: #f8f0e3;
                    min-height: 100px;
                    width: 100%;
                    border: 2px dashed #e0c9a1;
                    transition: background-color 0.2s;
                `}
              >
                  <SortableContext
                    items={withdrawnAisles}
                    strategy={rectSortingStrategy}
                  >
                      {withdrawnAisles.length > 0 ? (
                        <div css={css`
                            display: grid;
                            grid-template-columns: repeat(${ITEMS_PER_ROW}, 1fr);
                            gap: ${isMobile ? '0.5rem' : '1rem'};
                            width: 100%;
                        `}>
                            {withdrawnAisles.map((aisle) => (
                              <div
                                key={aisle.id}
                                css={css`
                                    position: relative;
                                    z-index: 1;
                                `}
                                className="grid-item withdrawn-item"
                              >
                                  <div css={css`width: 100%;`}>
                                      <Aisle
                                        id={aisle.id}
                                        aisle={aisle}
                                        onChange={newAisles => handleOnWithdrawnAisleChange(aisle.id, newAisles)}
                                      />
                                  </div>
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div css={css`
                            text-align: center;
                            padding: ${isMobile ? '1rem' : '2rem'};
                            color: #a3885f;
                            font-size: ${isMobile ? '0.9rem' : '1rem'};
                        `}>
                            {t('picking_path.withdrawn_zone_placeholder')}
                        </div>
                      )}
                  </SortableContext>
              </DroppableZone>
          </div>
      </div>
    )
}

export { WithdrawnZone }
